module.exports = __webpack_public_path__ + "img/d4534ee58df99c99e462a8a3927982b0.svg";